<template lang="pug">
v-autocomplete(
  dense,
  v-model="dataProductGroup",
  :disabled="disabled",
  :readonly="readonly",
  :label="label",
  :rules="rules",
  :items="listData",
  item-text="description",
  item-value="id",
  @change="onSelect",
  :required="required"
)
</template>
<script>
export default {
  name: "FSelectProductGroup",
  props: ["value", "disabled", "readonly", "label", "rules", "required"],
  data() {
    return {
      dataProductGroup: {},
      listData: [],
    };
  },
  mounted() {
    this.doLoad();
    this.doInit(this.value);
  },
  watch: {
    value(val) {
      this.doInit(val);
    },
  },
  methods: {
    doInit(values) {
      this.dataProductGroup = values ? values : null;
    },
    doLoad() {
      this.$http.get("/api/parameter/product-group").then((success) => {
        this.listData = success.data;
        this.dataProductGroup = this.listData ? this.listData[0].id : null;
        this.onSelect();
      });
    },
    onSelect() {
      this.$emit("input", this.dataProductGroup);
      this.$emit("select", this.dataProductGroup);
      this.$emit("productGroup", this.valueData());
    },
    valueData() {
      let result = null;
      this.listData.map((element) => {
        if (this.dataProductGroup === element.id) {
          result = element;
        }
      });
      return result;
    },
  },
};
</script>